export { Diamond as default } from './Diamond';
